module.exports = __webpack_public_path__ + "img/express.cc3a7619.png";